export default {"src":"/_next/static/image/src/statics/images/google-icon.9aefd664a7f66f6ccec05e42cbf6c6a1.svg","height":48,"width":48};